export default (context) => {
  context.$auth.registerLoginHandler(() => {
    context.app.store.dispatch('account/me');
  });

  context.$auth.registerLogoutHandler(() => {
    context.app.store.dispatch('account/resetUser');

    if (context.$getEnv('LOGOUT_URL')) {
      window.location.href = context.$getEnv('LOGOUT_URL');

      return;
    }

    if (context.$auth.isAuthenticationRequiredForRoute(
      context.route,
      context.$getEnv('AUTH_LOGIN_DEFAULT_REQUIRED', false),
    ) === true) {
      context.app.router.push('/');
    }
  });

  if (context.$auth.hasUserToken() === true) {
    context.$auth.triggerLoggedInEvent();
  }
};
